/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step1Inputs */

const en_dr_room_step1 = /** @type {(inputs: Dr_Room_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem`)
};

const id_dr_room_step1 = /** @type {(inputs: Dr_Room_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masalah`)
};

/**
* | output |
* | --- |
* | "Problem" |
*
* @param {Dr_Room_Step1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step1 = /** @type {((inputs?: Dr_Room_Step1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step1(inputs)
	return en_dr_room_step1(inputs)
});